<template>
  <div class="columns">

    <div class="column" v-for="(post, index) in posts.slice(0, 3)" :key="'post-' + index">
      <div class="card">
        <router-link :to="{ name: 'post', params: { uid: post.uid } }" class="card-image">
          <figure class="image is-4by3">
            <prismic-image :field="post.data.cover_photo"/>
          </figure>
        </router-link>
        <div class="card-content has-background-white-bis">
          <div class="content">
            <prismic-rich-text class="is-size-7" :field="post.data.post_title"/>
            {{ $prismic.richTextAsPlain(post.data.post_content).substr(0, 100) }} ...
            <router-link :to="{ name: 'post', params: { uid: post.uid } }">閱讀全文</router-link>
          </div>
          <div class="card-footer">
            <div class="time">
              <b-icon pack="fas" icon="calendar-alt" size="is-small"></b-icon><span> {{ formatDate(index) }}</span>&nbsp;&nbsp;&nbsp;
              <b-icon pack="fas" icon="user" size="is-small"></b-icon><span> Admin</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'EventCards',
  data() {
    return {
      posts: [],
    };
  },
  methods: {
    getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'posts'),
        { orderings: '[my.posts.event_date desc]' },
      ).then((response) => {
        this.posts = response.results;
      });
    },
    formatDate(index) {
      return moment(this.posts[index].data.event_date).format('MMM D, YYYY');
    },
    charCounter(index) {
      return this.$prismic.richTextAsPlain(this.posts[index].data.post_content).length;
    },
  },
  created() {
    this.getContent();
  },
};
</script>

<style scoped lang="scss">
.time {
  padding: 0.5rem 0 0 0;
  color: hsla(0, 0%, 29%, 0.5)
}

.content {
  min-height: 10em;
}

.card-footer {
  border-top: none;
}
</style>
